/* eslint-disable no-unsafe-optional-chaining */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'

// Store
import { actions } from 'core/store'

// Styled Elements
import {
  // Chip,
  Text,
  Label,
  Title,
  // SubTitle,
  TableColWrapper,
  // TableColContainer,
  TableRowWrapper,
  TableRowContainer,
  // StatusContainer,
} from './AiDocumentTableItem.elements'

// Views
import { CardTableItem } from 'views/components'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions
function AiDocumentTableItem(props) {
  // Destructure
  const { details } = props
  const { title, summary, core_metadata, id } = details

  // State

  return (
    <NavLink to={`/admin/ai/documents/${id}`} style={{ cursor: 'pointer' }}>
      <CardTableItem key={title}>
        <TableRowWrapper>
          <Title>{title}</Title>
        </TableRowWrapper>

        <TableColWrapper>
          <TableRowContainer>
            <Label>Summary: </Label>
            <Text>{summary}</Text>
          </TableRowContainer>

          <TableRowContainer>
            <Label>Core Metadata: </Label>
            <Text>{JSON.stringify(core_metadata)}</Text>
          </TableRowContainer>
        </TableColWrapper>
      </CardTableItem>
    </NavLink>
  )
}

// Default Props
AiDocumentTableItem.defaultProps = {}

// Proptypes Validation
AiDocumentTableItem.propTypes = {
  details: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    summary: PropTypes.string,
    core_metadata: PropTypes.string,
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(AiDocumentTableItem)
